<div class="color-panel">
  <!-- Saturation across, brightness down, on the pure hue. -->
  <div
    #area
    class="color-panel-area"
    [style.background-color]="hueColor"
    (pointerdown)="onPointerDown('area', $event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp()"
    (pointercancel)="onPointerUp()"
  >
    <span
      class="color-panel-thumb"
      role="slider"
      tabindex="0"
      [attr.aria-label]="hintArea"
      [style.left.%]="hsv.s * 100"
      [style.top.%]="(1 - hsv.v) * 100"
      [style.background-color]="hex"
      (keydown)="onKey('area', $event)"
    ></span>
  </div>

  <div
    #hueBar
    class="color-panel-hue"
    (pointerdown)="onPointerDown('hue', $event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp()"
    (pointercancel)="onPointerUp()"
  >
    <span
      class="color-panel-thumb color-panel-thumb--hue"
      role="slider"
      tabindex="0"
      [attr.aria-label]="hintHue"
      [attr.aria-valuenow]="hsv.h | number: '1.0-0'"
      aria-valuemin="0"
      aria-valuemax="360"
      [style.left.%]="(hsv.h / 360) * 100"
      [style.background-color]="hueColor"
      (keydown)="onKey('hue', $event)"
    ></span>
  </div>

  <div class="color-panel-footer">
    <input
      #hexInput
      class="color-panel-hex"
      [class.color-panel-hex--invalid]="hexInvalid"
      type="text"
      maxlength="7"
      spellcheck="false"
      [value]="hex.toUpperCase()"
      [attr.aria-label]="hintHex"
      (keydown.enter)="applyHex(hexInput.value)"
      (blur)="applyHex(hexInput.value)"
      (input)="hexInvalid = false"
    />
    @if (canPickFromScreen) {
      <button type="button" class="color-panel-eyedropper" [title]="hintEyedropper" [attr.aria-label]="hintEyedropper" (click)="pickFromScreen()">
        <!-- Pipette (Hugeicons style) -->
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
          <path
            d="M14.5 6.5L17.5 9.5M3 21L5 20.5L15.8 9.7C16.2 9.3 16.2 8.7 15.8 8.3L15.7 8.2C15.3 7.8 14.7 7.8 14.3 8.2L3.5 19L3 21ZM17 4.5L18.2 3.3C18.9 2.6 20 2.6 20.7 3.3C21.4 4 21.4 5.1 20.7 5.8L19.5 7L20 7.5C20.3 7.8 20.3 8.2 20 8.5L19.5 9C19.2 9.3 18.8 9.3 18.5 9L15 5.5C14.7 5.2 14.7 4.8 15 4.5L15.5 4C15.8 3.7 16.2 3.7 16.5 4L17 4.5Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    }
  </div>
</div>
